<template>
  <div>
    <!-- Modal form -->
    <b-modal
      id="modal-form"
      title="Tambah Jadwal Praktek"
      ok-title="Simpan"
      cancel-title="Batal"
      modal-class="hc-schedule-modal"
      header-class="hc-modal-header"
      footer-class="hc-modal-footer"
      body-class="hc-modal-body"
      @ok="modalOnSubmit"
      @hidden="modalOnHide"
      @show="modalOnShow">
      <template #modal-title>
        <div class="hc-modal-heading">
          <div class="hc-modal-heading-icon">
            <i class="fas fa-calendar-plus"></i>
          </div>
          <div>
            <h5 class="hc-modal-title-text">{{ editTarget ? 'Edit' : 'Tambah' }} Jadwal Praktek</h5>
            <span class="hc-modal-subtitle-text">Atur jadwal operasional dan jam praktik dokter</span>
          </div>
        </div>
      </template>

      <b-form @submit.stop.prevent="formOnSubmit" class="hc-schedule-form">
        <!-- Doctor Select -->
        <template v-if="!hasDoctor">
          <b-form-group
            id="input-group-doctor"
            class="hc-form-group">
            <label class="hc-field-label" for="input-doctor">
              <i class="fas fa-user-md"></i> Pilih Dokter
            </label>
            <treeselect
              v-model="form.doctor_id"
              :multiple="false"
              :options="doctors"
              placeholder="Pilih Dokter"
              class="hc-treeselect-clean" />
            <small class="text-danger mt-1 d-block">{{ error.doctor_id }}</small>
          </b-form-group>
        </template>

        <!-- Days Select -->
        <b-form-group
          id="input-group-schedule"
          class="hc-form-group">
          <label class="hc-field-label">
            <i class="far fa-calendar-alt"></i> Hari Praktek
          </label>
          <b-form-select
            v-model="form.day_name"
            :options="days"
            class="hc-custom-select"></b-form-select>
          <small class="text-danger mt-1 d-block">{{ error.day_name }}</small>
        </b-form-group>

        <!-- StartTime Picker -->
        <b-form-group
          id="input-group-start-time"
          class="hc-form-group">
          <label class="hc-field-label">
            <i class="far fa-clock"></i> Jam Mulai
          </label>
          <div class="hc-time-picker-shell">
            <div class="hc-time-box">
              <b-form-input
                id="input-time"
                placeholder="00"
                v-model="start_time.time"
                maxlength="2"
                class="hc-time-input"></b-form-input>
              <span class="hc-time-unit">Jam</span>
            </div>
            <span class="hc-time-colon">:</span>
            <div class="hc-time-box">
              <b-form-input
                id="input-time-minute"
                placeholder="00"
                v-model="start_time.minute"
                maxlength="2"
                class="hc-time-input"></b-form-input>
              <span class="hc-time-unit">Menit</span>
            </div>
          </div>
          <small class="text-danger mt-1 d-block">{{ error.start_time }}</small>
        </b-form-group>

        <!-- EndTime Picker -->
        <b-form-group
          id="input-group-end-time"
          class="hc-form-group">
          <label class="hc-field-label">
            <i class="far fa-clock"></i> Jam Selesai
          </label>
          <div class="hc-time-picker-shell">
            <div class="hc-time-box">
              <b-form-input
                id="input-end-time"
                placeholder="00"
                v-model="end_time.time"
                maxlength="2"
                class="hc-time-input"></b-form-input>
              <span class="hc-time-unit">Jam</span>
            </div>
            <span class="hc-time-colon">:</span>
            <div class="hc-time-box">
              <b-form-input
                id="input-end-time-minute"
                placeholder="00"
                v-model="end_time.minute"
                maxlength="2"
                class="hc-time-input"></b-form-input>
              <span class="hc-time-unit">Menit</span>
            </div>
          </div>
          <small class="text-danger mt-1 d-block">{{ error.end_time }}</small>
        </b-form-group>

        <!-- Input Duration -->
        <b-form-group
          id="input-group-duration"
          class="hc-form-group mb-0">
          <label class="hc-field-label">
            <i class="fas fa-hourglass-half"></i> Durasi Perjanjian
          </label>
          <b-form-select
            v-model="form.duration"
            :options="durations"
            class="hc-custom-select"></b-form-select>
          <small class="text-danger mt-1 d-block">{{ error.duration }}</small>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import DoctorModule from "@/core/modules/DoctorModule"
import Treeselect from "@riophae/vue-treeselect"
import validation from "@/core/modules/ValidationModule.js"
import module from "@/core/modules/CrudModule.js"
import Swal from "sweetalert2"
import "@riophae/vue-treeselect/dist/vue-treeselect.css"

export default {
  components: {
    Treeselect,
  },

  props: {
    form: Object,
    route: String,
    editTarget: String,
    hasDoctor: Boolean,
  },

  data() {
    return {
      error: {
        day_name: "",
        start_time: "",
        end_time: "",
        doctor_id: "",
        duration: "",
      },
      doctors: [{ label: "Pilih Dokter", id: "", isDisabled: true }],
      durations: [
        { value: "", text: "Pilih Durasi (Menit)", disabled: true },
        { value: 15, text: "15 Menit" },
        { value: 20, text: "20 Menit" },
        { value: 30, text: "30 Menit" },
        { value: 45, text: "45 Menit" },
        { value: 60, text: "60 Menit" },
      ],
      days: [
        { value: "", text: "Pilih Hari", disabled: true },
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
        "Minggu",
      ],
      start_time: {
        time: "",
        minute: "",
      },
      end_time: {
        time: "",
        minute: "",
      },
    }
  },

  methods: {
    resetDays() {
      this.days = [
        { value: "", text: "Pilih Hari", disabled: true },
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
        "Minggu",
      ]
    },

    async getDoctorsOption() {
      const data = await DoctorModule.getTreeSelect()
      this.doctors.push(...data)
    },

    async formOnSubmit() {
      // check if time empty
      if (this.start_time.time == "") {
        this.start_time.time = "00";
      }

      if (this.start_time.minute == "") {
        this.start_time.minute = "00";
      }

      if (this.end_time.time == "") {
        this.end_time.time = "00";
      }

      if (this.end_time.minute == "") {
        this.end_time.minute = "00";
      }

      this.form.start_time =
        this.start_time.time + ":" + this.start_time.minute;
      this.form.end_time = this.end_time.time + ":" + this.end_time.minute;

      let route;
      this.editTarget == ""
        ? (route = this.route)
        : (route = `${this.route}/${this.editTarget}`);
      let response = await module.submit(this.form, route);
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        this.$root.$emit("UpdateAvailableDoctor");
        Swal.fire(response.success.title, response.success.message, "success");

        this.start_time.time = "";
        this.start_time.minute = "";
        this.end_time.time = "";
        this.end_time.minute = "";

        if (typeof this.$route.query.redirect != "undefined") {
          this.$router.push({ name: this.$route.query.redirect });
          return;
        }
        // Hide Modal
        this.$bvModal.hide("modal-form");
        // Refresh Table
        this.$emit("formOnSubmit");
      }
    },

    modalOnSubmit(evt) {
      evt.preventDefault();
      this.formOnSubmit();
    },

    modalOnShow() {
      this.error = validation.clearValidationError(this.error);
      if (this.hasDoctor) {
        // this.selectDoctorOnChange({ id: this.$route.params.id })
        this.form.doctor_id = this.$route.params.id;
      } else {
        // Reset Days Option
        this.resetDays();
      }
    },

    modalOnHide() {
      this.error = validation.clearValidationError(this.error);
      this.form = validation.clearForm(this.form);

      this.start_time.time = "";
      this.start_time.minute = "";
      this.end_time.time = "";
      this.end_time.minute = "";

      // Reset Form
      delete this.form["_method"];
      if (this.hasDoctor) {
        // this.selectDoctorOnChange({ id: this.$route.params.id })
        this.form.doctor_id = this.$route.params.id;
      } else {
        // Reset Days Option
        this.resetDays();
      }
    },
  },

  watch: {
    "form.doctor_id": function (newVal) {
      if (typeof newVal === "undefined") this.form.doctor_id = "";
    },
  },

  mounted() {
    if (!this.hasDoctor)
      this.getDoctorsOption()
  }

}
</script>

<style lang="scss">
/* Modal Dialog Styling */
.hc-schedule-modal {
  z-index: 1100 !important;

  .modal-dialog {
    max-width: 520px !important;
    margin: 50px auto 30px !important;
  }

  .modal-content {
    border-radius: 20px !important;
    border: 1px solid #e7edf4 !important;
    box-shadow: 0 20px 60px rgba(var(--skin-deep-rgb), 0.14) !important;
    overflow: hidden;
  }

  .hc-modal-header {
    padding: 20px 24px 16px !important;
    border-bottom: 1px solid #edf2f7 !important;
    background: #ffffff !important;
  }

  .hc-modal-heading {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .hc-modal-heading-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: rgba(var(--skin-secondary-rgb), 0.1);
    color: var(--skin-secondary);
    font-size: 18px;
    flex-shrink: 0;
  }

  .hc-modal-title-text {
    margin: 0 0 2px !important;
    font-size: 17px !important;
    font-weight: 700 !important;
    color: #1a2433 !important;
  }

  .hc-modal-subtitle-text {
    font-size: 12px;
    color: #64748b;
  }

  .hc-modal-body {
    padding: 24px !important;
    background: #ffffff !important;
  }

  .hc-modal-footer {
    padding: 16px 24px !important;
    background: #f8fafc !important;
    border-top: 1px solid #edf2f7 !important;
    gap: 10px;

    .btn-secondary {
      min-height: 42px !important;
      padding: 0 20px !important;
      border-radius: 10px !important;
      background: #ffffff !important;
      border: 1px solid #cbd5e1 !important;
      color: #475569 !important;
      font-size: 13px !important;
      font-weight: 600 !important;

      &:hover {
        background: #f1f5f9 !important;
        color: #1e293b !important;
      }
    }

    .btn-primary {
      min-height: 42px !important;
      padding: 0 24px !important;
      border-radius: 10px !important;
      background: linear-gradient(135deg, var(--skin-primary), var(--skin-secondary)) !important;
      border: none !important;
      color: #ffffff !important;
      font-size: 13px !important;
      font-weight: 700 !important;
      box-shadow: 0 6px 16px rgba(var(--skin-secondary-rgb), 0.22) !important;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 8px 20px rgba(var(--skin-secondary-rgb), 0.3) !important;
      }
    }
  }

  .hc-form-group {
    margin-bottom: 20px;
  }

  .hc-field-label {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 13px;
    font-weight: 600;
    color: #334155;

    i {
      color: var(--skin-secondary);
      font-size: 14px;
    }
  }

  .hc-custom-select {
    height: 46px !important;
    padding: 0 16px !important;
    border-radius: 10px !important;
    border: 1px solid #cbd5e1 !important;
    background-color: #f8fafc !important;
    font-size: 13px !important;
    color: #1e293b !important;
    box-shadow: none !important;
    transition: all 0.2s ease;

    &:focus {
      border-color: var(--skin-secondary) !important;
      background-color: #ffffff !important;
      box-shadow: 0 0 0 3px rgba(var(--skin-secondary-rgb), 0.12) !important;
    }
  }

  .hc-time-picker-shell {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .hc-time-box {
    display: flex;
    align-items: center;
    flex: 1;
    height: 46px;
    padding: 0 12px;
    background: #f8fafc;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    transition: all 0.2s ease;

    &:focus-within {
      background: #ffffff;
      border-color: var(--skin-secondary);
      box-shadow: 0 0 0 3px rgba(var(--skin-secondary-rgb), 0.12);
    }
  }

  .hc-time-input {
    height: 100% !important;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    color: #0f172a !important;
    text-align: center !important;
    box-shadow: none !important;

    &::placeholder {
      color: #94a3b8 !important;
      font-weight: 500 !important;
    }
  }

  .hc-time-unit {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
  }

  .hc-time-colon {
    font-size: 20px;
    font-weight: 700;
    color: #94a3b8;
  }
}
</style>